// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__ASomj","submit":"Form_submit__VBGW8","submitFullWidth":"Form_submitFullWidth__msnBV","buttonWrapper":"Form_buttonWrapper__bC5Cx"};